import { createSlice } from '@reduxjs/toolkit'
import { pick } from 'lodash-es'
import { updateAddressVO } from '@/store/serviceProviderSlice'
import type * as Types from './types'

import type { AppDispatch, AppGetState } from '@/store'
import { FormInstance } from 'antd-mobile/es/components/form'

export const initialState = {
  provinces: [],
  cities: [],
  districts: [],
}

export const senderAddressSlice = createSlice({
  name: 'senderAddressForm',
  initialState,
  reducers: {
    update(state, action) {
      const { payload } = action
      return { ...state, ...payload }
    },
  },
})

export const { actions, reducer } = senderAddressSlice
export default reducer

/** 初始化发货国家 */
export const initSenderAddressForm = (params: { formValues?: Types.ISenderAddressFormValues }) => async (dispatch: AppDispatch, _getState: AppGetState, form: FormInstance) => {
  const { formValues } = params
  const { departure_area, departure_zipCode } = formValues

  // const { departure_countryCode } = form.getFieldsValue()
  // departure_countryCode && dispatch(changeSenderAddressAreaLang({ countryCode: departure_countryCode }))

  // 最后再执行一次，比如 city 会清空 district
  await dispatch(
    updateAddressVO({
      departure_city: departure_area?.city,
      departure_district: departure_area?.district,
      departure_province: departure_area?.province,
      departure_town: departure_area?.town,
      departure_zipCode: departure_zipCode,
      departure_address: formValues?.departure_address,
      departure_addressTwo: formValues?.departure_addressTwo,
      departure_fullName: formValues?.departure_fullName,
      departure_mobile: formValues?.departure_mobile,
    })
  )

  const updateFormValues = pick(
    formValues,
    Object.keys(formValues).filter((key) => key.startsWith('departure_'))
  )
  form.setFieldsValue(updateFormValues)
}

/** 获取发货可视配置 */
export const getSenderAddressVisibility = () => (_dispatch: AppDispatch, getState: AppGetState, form: FormInstance) => {
  const { address } = getState()
  const countryCode = form.getFieldValue('departure_countryCode')
  const addressConfig = address?.addressConfig?.[countryCode]

  /* 只有省份隐藏 */
  const isProvinceHidden = !addressConfig.provinceVisibility && addressConfig.cityVisibility && addressConfig.districtVisibility

  /* 只有城市隐藏 */
  const isCityHidden = !addressConfig.cityVisibility && addressConfig.provinceVisibility && addressConfig.districtVisibility

  /* 只有区显示 */
  const isOnlyDistrictShow = addressConfig.districtVisibility && !addressConfig.provinceVisibility && !addressConfig.cityVisibility

  return { isProvinceHidden, isCityHidden, isOnlyDistrictShow }
}
